<dx-select-box [dataSource]="partners | async"
               displayExpr="name"
               [showClearButton]="true"
               (onSelectionChanged)="onSelectionChanged($event)"
               [value]="partner"
               [width]="200"></dx-select-box>
